import { PageTitle } from "@/components/page-title";
import { Card, CardContent, CardHeader, CardTitle } from "components/ui/card";
import { Scale } from "lucide-react";

interface LegalLinkLinks {
  text: string;
  href: string;
}

interface LegalLink {
  name: string;
  links: LegalLinkLinks[];
}

const legalLinks: LegalLink[] = [
  {
    name: "Terms",
    links: [
      {
        text: "Geoscape General Terms",
        href: "https://geoscape.com.au/wp-content/uploads/2025/05/Geoscape-Australia-Geoscape-General-Terms-of-Use-v2.0-July-2025.pdf",
      },
      {
        text: "Previous Geoscape General Terms",
        href: "https://geoscape.com.au/wp-content/uploads/2025/05/Previous-Geoscape-Developer-Terms-and-Terms-of-Use.pdf",
      },
      {
        text: "Geoscape Specific API Terms",
        href: "https://geoscape.com.au/legal/geoscape-developer-specific-terms",
      },
    ],
  },
  {
    name: "End-User License Agreements",
    links: [
      {
        text: "Geoscape Data End User License Agreement (EULA)",
        href: "https://geoscape.com.au/legal/geoscape-developer-buildings-api-data-eula",
      },
      {
        text: "Mailpoint Mandatory End User Terms",
        href: "https://geoscape.com.au/legal/geoscape-developer-mailpoint-eula",
      },
    ],
  },
  {
    name: "Other",
    links: [
      {
        text: "Geoscape Data Copyright & Disclaimer",
        href: "https://geoscape.com.au/data-copyright-disclaimer/",
      },
      {
        text: "Geoscape Privacy Policy",
        href: "https://geoscape.com.au/privacy-policy/",
      },
    ],
  },
];

export const LegalPage = () => {
  return (
    <div className="flex flex-col gap-4 h-full">
      <PageTitle
        icon={Scale}
        title={"Legal"}
        description={
          "Terms of use, end-user license agreements, and privacy information for Geoscape products and data."
        }
      />
      {legalLinks.map((section) => (
        <Card key={section.name}>
          <CardHeader>
            <CardTitle>{section.name}</CardTitle>
          </CardHeader>
          <CardContent>
            <ul className="list-disc pl-5 space-y-1">
              {section.links.map((link) => (
                <li key={link.text}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-foreground hover:text-primary hover:underline transition-colors"
                  >
                    {link.text}
                  </a>
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
